//  ----------      START   IMPORT  BLOCK       ----------
//  API
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
//  ----------      END   IMPORT  BLOCK       ----------

export default class VerifyService extends APIService {
    
  async verify(token) {
    if (!token) {
      throw new Error('Token is missing');
    }

    // NOTE: This POST call will include the standard 'Authorization: Bearer <token>' 
    // header due to the apiClient interceptor. 
    // It also passes the token in the body: { token: token }
    // This assumes your API is robust enough to handle the redundant token headers,
    // which is common for verification endpoints.
    
    return this.post(API_ROUTES.verify_user, { token: token });
  }
}